// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  font-size: medium;
  text-align: right;
}

table tbody {
  overflow-y: scroll;
  overflow-x: hidden;
  display: block;
  margin: 0 auto;
  padding-left: 20%;
}

table tbody .small_row {
  padding-left: 10%;
}

#small_right_field {
  margin-left: -50px;
}

table tbody th {
  text-align: left;
  width: 60%;
}

table tbody::-webkit-scrollbar {
  -webkit-appearance: none;
}

table tbody::-webkit-scrollbar :vertical {
  width: 2px;
}

table tbody::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.3);
}

table thead {
  display: table;
  table-layout: fixed;
  text-align: center;
  width: 100%;
}

table tr {
  display: table;
  table-layout: fixed;
  width: 50%;
}

.table-container {
  margin-top: 10px;
  max-height: 300px;
  overflow: auto;
}

td {
  text-align: left;
  height: 45px;
}

input {
  font-size: medium;
}

.actionButtonArea {
  margin-top: 20px;
  padding-bottom: 12px;
}

.confirm-button {
  background-color: #90CAFC;
}

.error {
  color: red;
  font-size: small;
}

.mat-mdc-form-field {
  width: 300px;
}

/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-flex > .mat-form-field-infix {
  padding: 0.4em 0px !important;
}

/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-label-wrapper {
  top: -1.5em;
}

/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
::ng-deep .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 300px;
}

:host ::ng-deep .mat-mdc-form-field-hint-wrapper {
  display: contents;
}

:host ::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {
  background: inherit;
}

.selectSite {
  color: #5F58FF;
  text-decoration: underline;
}

.userName {
  width: 300px;
}

.tr {
  vertical-align: baseline;
}

.loginIDFormTitle, .passwordTitle, .confirmPasswordTitle {
  padding-bottom: 1.34375em;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/user-add-dialog/user-add-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AACJ;;AAEA;EAEI,iBAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,wBAAA;AAAJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,uBAAA;EACA,oCAAA;AACJ;;AAEA;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,cAAA;EACA,mBAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,gBAAA;EACA,YAAA;AACJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,oBAAA;AAAJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,UAAA;EACA,gBAAA;AACJ;;AAGA;EACI,YAAA;AAAJ;;AAEA,iIAAA;AACA;EAAyD,6BAAA;AAEzD;;AADA,iIAAA;AACA;EAA0C,WAAA;AAK1C;;AAHA,iIAAA;AACA;EACI,yCAAA;EACA,YAAA;AAMJ;;AAHA;EACI,iBAAA;AAMJ;;AAHA;EACI,mBAAA;AAMJ;;AAHA;EACI,cAAA;EACA,0BAAA;AAMJ;;AAHA;EACI,YAAA;AAMJ;;AAHA;EACI,wBAAA;AAMJ;;AAHA;EACI,yBAAA;AAMJ","sourcesContent":["table{\n    font-size: medium;\n    text-align: right;    \n}\n\ntable tbody{\n    overflow-y: scroll;\n    overflow-x: hidden;\n    display: block;\n    margin: 0 auto;\n    padding-left: 20%;\n}\n\ntable tbody .small_row{\n\n    padding-left: 10%;\n}\n\n#small_right_field{\n    margin-left: -50px;\n}\n\ntable tbody th{\n    text-align: left;\n    width: 60%;\n}\n\ntable tbody::-webkit-scrollbar{\n    -webkit-appearance: none;\n}\ntable tbody::-webkit-scrollbar :vertical {\n    width: 2px;\n}\n\ntable tbody::-webkit-scrollbar-thumb{\n    border-radius: 8px;\n    border: 2px solid white;\n    background-color: rgba(0,0,0,0.3);\n}\n\ntable thead{\n    display: table;\n    table-layout: fixed;\n    text-align: center;\n    width: 100%; \n}\n\ntable tr{\n    display: table;\n    table-layout: fixed;\n    width: 50%;\n}\n\n.table-container {\n    margin-top: 10px;\n    max-height: 300px;\n    overflow: auto;\n  }\n\ntd{\n    text-align: left;\n    height: 45px\n}\n\n\ninput{\n    font-size: medium;\n}\n\n.actionButtonArea{\n    margin-top: 20px;\n    padding-bottom: 12px;\n}\n.confirm-button{\n    background-color: #90CAFC;\n}\n\n.error{\n    color: red;\n    font-size: small;\n\n}\n\n.mat-mdc-form-field {\n    width: 300px;\n}\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n::ng-deep .mat-form-field-flex > .mat-form-field-infix { padding: 0.4em 0px !important;}\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n::ng-deep .mat-form-field-label-wrapper { top: -1.5em; }\n\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */\n::ng-deep .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\n    transform: translateY(-1.1em) scale(.75);\n    width: 300px;\n}\n\n:host ::ng-deep .mat-mdc-form-field-hint-wrapper {\n    display: contents;\n}\n\n:host ::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {\n    background: inherit;\n}\n\n.selectSite{\n    color: #5F58FF;\n    text-decoration: underline;\n}\n\n.userName{\n    width: 300px;\n}\n\n.tr{\n    vertical-align: baseline;\n}\n\n.loginIDFormTitle, .passwordTitle, .confirmPasswordTitle{\n    padding-bottom: 1.34375em;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
